// extracted by mini-css-extract-plugin
export default {"controls":"hKNVFY","monthControls":"QEZBWx","mobileFontSize":"xg981R","monthButton":"pgdLwu","back":"uSfWii","month":"n5kPUI","loading":"TSvqg6","next":"J8AvVb","days":"ZmBPei"};